import "./HotelDigitalMarketingRevenueIntegration.module.css";
import Header from "@/reusable_sections/Header";
import Herogrowthstrategy from "./sections/Herogrowthstrategy";
import Contact from "./sections/Contact";
import Synergy from "./sections/Synergy";
import Revenuefaq from "./sections/Revenuefaq";
import RevenueIntegration from "./sections/RevenueIntegration";
import Footer from "@/reusable_sections/Footer";
export default function HotelDigitalMarketingRevenueIntegrationPage() {
  return <div>
      <Header />
      <Herogrowthstrategy />
      <Contact />
      <Synergy />
      <Revenuefaq />
      <RevenueIntegration />
      <Footer />
    </div>;
}